export const config = {
  appTheme: process.env.REACT_APP_THEME,
};

export const appThemes = {
  rtk: 'rtk',
  calltraffic: 'calltraffic',
};
